import PlayCanvasService from "../../../services/PlayCanvasService/PlayCanvasService";
import { changeShowModal } from "../../reducers/app/appReducer";
import {
  getActiveEnvironmentId,
  getEnvironments,
} from "../../reducers/ui/selectors/enviromentSelectors";
import { AppStore } from "../../store";
import {
  resetDataSceneHandler,
  registerSelectionHandler,
} from "./sceneHandlers";
import { updateCameraSetting } from "../../reducers/ui/uiReducer";
import { getCameraFov } from "../../../utils/functions/playcanvas/getCameraFov";

// Wait for the PlayCanvas iframe to dispatch readiness (or for the flag)
export const waitForPlaycanvasReady = (timeoutMs: number = 8000) =>
  new Promise<void>(resolve => {
    try {
      if ((window as any)?.playCanvasReady) return resolve();
      const onReady = () => {
        window.removeEventListener("playcanvas-ready", onReady as any);
        resolve();
      };
      window.addEventListener("playcanvas-ready", onReady as any, {
        once: true,
      });
      setTimeout(() => {
        window.removeEventListener("playcanvas-ready", onReady as any);
        resolve();
      }, timeoutMs);
    } catch {
      resolve();
    }
  });

export const changeSceneEnvironmentById = (id: number) => {
  return async (store: AppStore) => {
    const state = store.getState();
    const environmentData = getEnvironments(state);

    const environment = environmentData?.find(env => env.id === id);
    if (!environment) {
      console.error(`Environment with id ${id} not found`);
      return;
    }

    // store.dispatch(changeShowModal({ nameModal: "loader", stateModal: true }));

    try {
      await waitForPlaycanvasReady();

      resetDataSceneHandler()(store);

      await PlayCanvasService.changeScene(environment.name);
      try {
        const sceneFov = await getCameraFov(environment.name);
        if (typeof sceneFov === "number") {
          store.dispatch(
            updateCameraSetting({
              key: "fov",
              value: sceneFov,
            })
          );
        }
      } catch (error) {
        console.warn(error);
      }

      await new Promise(resolve => setTimeout(resolve, 500));

      // Load asset manager and re-register selection handler after scene change
      try {
        await PlayCanvasService.loadAssetManager();
        registerSelectionHandler(store);
      } catch (error) {
        console.error("Failed to register selection handler:", error);
      }
      // Notify listeners that the scene has changed so they can reapply view-dependent settings (FOV)
      try {
        window.dispatchEvent(new Event("playcanvas-scene-changed"));
      } catch {}
    } finally {
      store.dispatch(
        changeShowModal({ nameModal: "loader", stateModal: false })
      );
    }
  };
};

export const initFirstEnvironment = () => {
  return async (store: AppStore) => {
    const state = store.getState();
    const environmentData = getEnvironments(state);
    const activeEnvironment = getActiveEnvironmentId(state);

    if (environmentData.length === 0) {
      console.warn("No environments available to initialize.");
      return;
    }

    await changeSceneEnvironmentById(activeEnvironment)(store);
  };
};
